import { bootstrapApp } from './bootstrap';

void bootstrapApp();